<template>
  <div class="tradetable">
    <!-- <p class="guowaip" style="margin-top:0">
     ◆ 国投安信期货有限公司
    </p> -->
    <p class="guowaip" style="margin-top:0">
      ◆ 渤海期货股份有限公司
    </p>
    <p class="guowaip">
      ◆ 方正中期期货有限公司
    </p>
    <p class="guowaip" >
      ◆ 华融融达期货股份有限公司
    </p>
    <p class="guowaip" >
      ◆ 金瑞期货股份有限公司
    </p>
    <p class="guowaip" >
      ◆ 南华期货股份有限公司
    </p>
    <!-- <p class="guowaip" >
      ◆ 申银万国期货有限公司
    </p> -->
    <p class="guowaip" >
        ◆ 五矿期货有限公司
    </p>
     <p class="guowaip" style="margin-top:22px">以上期货公司支持股票期权交易。</p>
  </div>
</template>

<script>
export default {};
</script>

<style scpoed>
.tradetable {
  width: 720px;
  margin: 0 auto;
}
.guowaip {
  height: 30px;
  line-height: 30px;
  letter-spacing: 1px;
 margin-top: 15px;
 /* font-family: '仿宋' ,sans-serif; */
}
.acom {
  color: black;
  text-decoration: none;
  margin-right: 35px;
}
.acom:hover {
  color: black;
}
</style>